
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { CategoryModel } from '@/models/category.model';

@Component({})
export default class CategoriesAmbassador extends Vue {
  @Prop({ required: true })
  category!: CategoryModel;
}
